import { FRAME_NAMES } from "./constants";
import { createAction } from "./utils/createAction";
import {
  TokenizeResponsePayloadError,
  TokenizeResponsePayloadSuccess,
} from "./api/tokenizeTypes";

export const fieldRenderedAction = createAction("fieldRenderedAction")<
  keyof typeof FRAME_NAMES
>();

export const setCardSchemeAction = createAction(
  "setCardSchemeAction"
)<string>();

export const fieldValidationAction = createAction("fieldValidationAction")<{
  field: keyof typeof FRAME_NAMES;
  isValid: boolean;
}>();

export const cardValidationAction = createAction(
  "cardValidationAction"
)<boolean>();

export const tokenizeFailedAction = createAction("tokenizeFailedAction")<
  TokenizeResponsePayloadError["error"]
>();

export const tokenizeSuccessAction = createAction(
  "tokenizeSuccessAction"
)<TokenizeResponsePayloadSuccess>();

export const checkCvvFailedAction = createAction("checkCvvFailedAction")<
  TokenizeResponsePayloadError["error"]
>();

export const checkCvvSuccessAction = createAction(
  "checkCvvSuccessAction"
)<TokenizeResponsePayloadSuccess>();
